<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <!-- <el-col :span="12" class="item">
                <el-form-item label="排班时间"  required prop="time">
                    <el-date-picker
                        v-model="addForm.time"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOption"
                        style="width:100%">
                    </el-date-picker>
                </el-form-item>
            </el-col> -->
            <el-col :span="12" class="item">
              <el-form-item label="排班类型"  required prop="type">
                <el-select v-model="addForm.type" placeholder="" @change="selectType" style="width:100%">
                  <el-option
                      v-for="(item,i) in typeValue"
                      :key="i"
                      :label="item"
                      :value="i">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="item">
                <el-card class="box-card" shadow='never'>
                  <div slot="header" class="clearfix">
                    <span>{{schedulName1}}</span>
                  </div>
                  <el-col :span="12" class="item">
                    <el-form-item label="护士"  required prop="nurseCodeArr1">
                      <el-select
                          v-model="addForm.nurseCodeArr1"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择护士">
                        <el-option
                            v-for="item in nurseList"
                            :key="item.nurseCode"
                            :label="item.name"
                            :value="item.nurseCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item">
                    <el-form-item label="护工"  required prop="nurseAideCodeArr1">
                      <el-select
                          v-model="addForm.nurseAideCodeArr1"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择护工">
                        <el-option
                            v-for="item in nurseAideList"
                            :key="item.nurseAideCode"
                            :label="item.name"
                            :value="item.nurseAideCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-card>
              </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
                <el-card class="box-card" shadow='never'>
                  <div slot="header" class="clearfix">
                    <span>{{schedulName2}}</span>
                  </div>
                  <el-col :span="12" class="item">
                    <el-form-item label="护士"  required prop="nurseCodeArr2">
                      <el-select
                          v-model="addForm.nurseCodeArr2"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择护士">
                        <el-option
                            v-for="item in nurseList"
                            :key="item.nurseCode"
                            :label="item.name"
                            :value="item.nurseCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item">
                    <el-form-item label="护工"  required prop="nurseAideCodeArr2">
                      <el-select
                          v-model="addForm.nurseAideCodeArr2"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择护工">
                        <el-option
                            v-for="item in nurseAideList"
                            :key="item.nurseAideCode"
                            :label="item.name"
                            :value="item.nurseAideCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-card>
              </el-col>
          </el-row>

          <el-row v-if="addForm.type>0" style="margin-top: 10px;">
            <el-col :span="24" class="item">
                <el-card class="box-card" shadow='never'>
                  <div slot="header" class="clearfix">
                    <span>{{schedulName3}}</span>
                  </div>
                  <el-col :span="12" class="item">
                    <el-form-item label="护士"  required prop="nurseCodeArr3">
                      <el-select
                          v-model="addForm.nurseCodeArr3"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择护士">
                        <el-option
                            v-for="item in nurseList"
                            :key="item.nurseCode"
                            :label="item.name"
                            :value="item.nurseCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item">
                    <el-form-item label="护工"  required prop="nurseAideCodeArr3">
                      <el-select
                          v-model="addForm.nurseAideCodeArr3"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择护工">
                        <el-option
                            v-for="item in nurseAideList"
                            :key="item.nurseAideCode"
                            :label="item.name"
                            :value="item.nurseAideCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-card>
              </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['nurseList','nurseAideList'],
  data() {
    return {
      loading: false,

      schedulName1:'白班',
      schedulName2:'夜班',

      schedulName3:'晚班',

      typeValue:['两班制','三班制'],

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        timeArr:[],
        type:0,
        nurseCodeArr1:[],
        nurseCodeArr2:[],
        nurseCodeArr3:[],
        nurseAideCodeArr1:[],
        nurseAideCodeArr2:[],
        nurseAideCodeArr3:[],
        schedulingPlan:[],
      },

      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      rules:{
        time:[
          { required: true, message: '请选择时间', trigger: 'blur' },
        ],
        type:[{required: true, message: '请选择护理排班类型', trigger: 'blur' }],
        nurseCodeArr1:[{ required: true, message: '请选择护士', trigger: 'blur' }],
        nurseCodeArr2:[{ required: true, message: '请选择护士', trigger: 'blur' }],
        nurseCodeArr3:[{ required: true, message: '请选择护士', trigger: 'blur' }],
        nurseAideCodeArr1:[{ required: true, message: '请选择护工', trigger: 'blur' }],
        nurseAideCodeArr2:[{ required: true, message: '请选择护工', trigger: 'blur' }],
        nurseAideCodeArr3:[{ required: true, message: '请选择护工', trigger: 'blur' }],
      }

    }
  },

  methods: {
    init(dateList){
      //console.log(dateList);
      this.$refs.addForm.resetFields();
      this.selectType(this.addForm.type)
      this.addForm.timeArr=dateList
    },

    closeSelf() {
      this.$emit("closeAdd");
    },

    selectType(e){
      if(e==1){
        this.schedulName1='早班'
        this.schedulName2='中班'
      }else{
        this.schedulName1='白班'
        this.schedulName2='夜班'
      }
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.addForm.schedulingPlan = [];
      this.addForm.schedulingPlan.push({nurseCodeArr:this.addForm.nurseCodeArr1,nurseAideCodeArr:this.addForm.nurseAideCodeArr1})
      this.addForm.schedulingPlan.push({nurseCodeArr:this.addForm.nurseCodeArr2,nurseAideCodeArr:this.addForm.nurseAideCodeArr2})
      if(this.addForm.type>0){
        this.addForm.schedulingPlan.push({nurseCodeArr:this.addForm.nurseCodeArr3,nurseAideCodeArr:this.addForm.nurseAideCodeArr3})
      }

      this.addForm.type=this.addForm.type+2

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingScheduling/AddMany",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
